"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetFormatToJSON = exports.AssetFormatFromJSONTyped = exports.AssetFormatFromJSON = exports.AssetFormat = void 0;
/**
 * Format of the asset.
 * @export
 */
exports.AssetFormat = {
    Audio: 'AUDIO',
    Video: 'VIDEO',
    Image: 'IMAGE',
    Survey: 'SURVEY',
    Uri: 'URI',
    Multi: 'MULTI'
};
function AssetFormatFromJSON(json) {
    return AssetFormatFromJSONTyped(json, false);
}
exports.AssetFormatFromJSON = AssetFormatFromJSON;
function AssetFormatFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AssetFormatFromJSONTyped = AssetFormatFromJSONTyped;
function AssetFormatToJSON(value) {
    return value;
}
exports.AssetFormatToJSON = AssetFormatToJSON;
